import React from 'react';
import {
  BalancingIcon,
  BuildableIcon,
  Center,
  FlexibleIcon,
  NourishingIcon,
  RefiningIcon,
  Stack,
  Text,
} from '../../components';

export const BenefitsAndPerksData = [
  {
    icon: <BalancingIcon />,
    title: 'Health and Wellbeing',
    description:
      'Option for no-cost medical, dental, and vision insurance - Glossier covers 100% of the premiums. Access to mental health benefits, direct primary care, annual wellbeing stipend, and caregiver support benefits.',
  },
  {
    icon: <NourishingIcon />,
    title: 'Family',
    description:
      'Generous parental leave of 18 weeks for all parents, with transition back to work program following leave. Access to fertility and family planning reimbursement, along with resources to support you in your family forming-journey.',
  },
  {
    icon: <FlexibleIcon />,
    title: 'Time Away',
    description:
      'Generous paid time off, plus a one month paid sabbatical after your first 4 years. Access to leave programs to take care of yourself and your family when you need it, plus time off for volunteerism to support your community and causes you care about.',
  },
  {
    icon: <RefiningIcon />,
    title: 'Finance',
    description:
      'Company equity awards. Plan for the future with access to 401(k) program, 100% employer-sponsored life and disability insurance, and voluntary supplemental life insurance.',
  },
  {
    icon: <BuildableIcon />,
    title: 'Growth & Development',
    description:
      'Internal mobility program to support career growth at Glossier. Glossier Talks speaker series and learning opportunities. Exclusive Fireside Chats with thought leaders and inspirational industry experts.',
  },
];

export const BenefitsAndPerksComponent = (props) => {
  let { value, align } = props;
  let { icon, title, description } = value || {
    icon: '',
    title: '',
    description: '',
  };
  return (
    <Stack size={4}>
      {align === 'left' ? icon : <Center>{icon}</Center>}
      <Text align={align} textType="primary1">
        {title}
      </Text>
      <Text align={align} textType="primary2">
        {description}
      </Text>
    </Stack>
  );
};
